import React from 'react';
import { Button } from 'antd';
import { ReactComponent as SolarGenIcon } from '../../static/icons/solar_energy_generated.svg';
import { ReactComponent as GridImportIcon } from '../../static/icons/energy_brought.svg';
import { ReactComponent as SoldSiteIcon } from '../../static/icons/energy_sold_site.svg';
import { ReactComponent as SoldGridIcon } from '../../static/icons/energy_sold_grid.svg';
import { ReactComponent as BessSolarIcon } from '../../static/icons/bess_solar_charged.svg';
import { ReactComponent as BessGridIcon } from '../../static/icons/bess_grid_charged.svg';
import { ReactComponent as BessSoldSiteIcon } from '../../static/icons/bess_sold_site.svg';
import { ReactComponent as BessSoldGridIcon } from '../../static/icons/bess_sold_grid.svg';

const SummaryButtons = ({ devices = 0, onlineDevices = 0 }) => (
  <div className="summaryButtons">
    <Button type="primary" onClick={() => { /* TODO */ }}>
      <div className="summaryBtnContent">
        <div className="summaryBtnIconWrapper">
          <SolarGenIcon className="summaryBtnIcon" />
        </div>
        <div className="summaryBtnText">
          <div className="summaryBtnTitle">Solar Energy Generated</div>
          <div className="summaryBtnSubtitle">{onlineDevices}/{devices} Inverters Online</div>
        </div>
      </div>
    </Button>
    <Button onClick={() => { /* TODO */ }}>
      <div className="summaryBtnContent">
        <div className="summaryBtnIconWrapper">
          <GridImportIcon className="summaryBtnIcon" />
        </div>
        <div className="summaryBtnText">
          <div className="summaryBtnTitle">Energy Brought from Grid</div>
          <div className="summaryBtnSubtitle">{onlineDevices}/{devices} Inverters Online</div>
        </div>
      </div>
    </Button>
    <Button onClick={() => { /* TODO */ }}>
      <div className="summaryBtnContent">
        <div className="summaryBtnIconWrapper">
          <SoldSiteIcon className="summaryBtnIcon" />
        </div>
        <div className="summaryBtnText">
          <div className="summaryBtnTitle">Energy Sold to Site</div>
          <div className="summaryBtnSubtitle">{onlineDevices}/{devices} Inverters Online</div>
        </div>
      </div>
    </Button>
    <Button onClick={() => { /* TODO */ }}>
      <div className="summaryBtnContent">
        <div className="summaryBtnIconWrapper">
          <SoldGridIcon className="summaryBtnIcon" />
        </div>
        <div className="summaryBtnText">
          <div className="summaryBtnTitle">Energy Sold to Grid</div>
          <div className="summaryBtnSubtitle">{onlineDevices}/{devices} Inverters Online</div>
        </div>
      </div>
    </Button>
    <Button onClick={() => { /* TODO */ }}>
      <div className="summaryBtnContent">
        <div className="summaryBtnIconWrapper">
          <BessSolarIcon className="summaryBtnIcon" />
        </div>
        <div className="summaryBtnText">
          <div className="summaryBtnTitle">BESS: Solar Charged</div>
          <div className="summaryBtnSubtitle">{onlineDevices}/{devices} Inverters Online</div>
        </div>
      </div>
    </Button>
    <Button onClick={() => { /* TODO */ }}>
      <div className="summaryBtnContent">
        <div className="summaryBtnIconWrapper">
          <BessGridIcon className="summaryBtnIcon" />
        </div>
        <div className="summaryBtnText">
          <div className="summaryBtnTitle">BESS: Grid Charged</div>
          <div className="summaryBtnSubtitle">{onlineDevices}/{devices} Inverters Online</div>
        </div>
      </div>
    </Button>
    <Button onClick={() => { /* TODO */ }}>
      <div className="summaryBtnContent">
        <div className="summaryBtnIconWrapper">
          <BessSoldSiteIcon className="summaryBtnIcon" />
        </div>
        <div className="summaryBtnText">
          <div className="summaryBtnTitle">BESS: Sold to Site</div>
          <div className="summaryBtnSubtitle">{onlineDevices}/{devices} Inverters Online</div>
        </div>
      </div>
    </Button>
    <Button onClick={() => { /* TODO */ }}>
      <div className="summaryBtnContent">
        <div className="summaryBtnIconWrapper">
          <BessSoldGridIcon className="summaryBtnIcon" />
        </div>
        <div className="summaryBtnText">
          <div className="summaryBtnTitle">BESS: Sold to Grid</div>
          <div className="summaryBtnSubtitle">{onlineDevices}/{devices} Inverters Online</div>
        </div>
      </div>
    </Button>
  </div>
);

export default SummaryButtons;
